// extracted by mini-css-extract-plugin
export var contact = "footer-module--contact--2ada8";
export var darkBg = "footer-module--darkBg--7d333";
export var lineSeparatorContainer = "footer-module--lineSeparatorContainer--fc1e4";
export var logo = "footer-module--logo--e67c9";
export var logos = "footer-module--logos--417d2";
export var menu = "footer-module--menu--d92e1";
export var toggleContainer = "footer-module--toggleContainer--ce943";
export var wrapper = "footer-module--wrapper--f9fe9";